var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      attrs: {
                        "align-v": "end",
                        offset: "0",
                        "offset-lg": "6",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "apeironGwApp.lieSnp.acciones.buscar"
                          ),
                        },
                        on: {
                          keyup: function ($event) {
                            return _vm.buscarEnLie()
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroLies,
                          callback: function ($$v) {
                            _vm.filtroLies = $$v
                          },
                          expression: "filtroLies",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          bordered: "",
                          small: "",
                          "thead-class": "custom-header",
                          items: _vm.liesFiltradas,
                          fields: _vm.fieldsLies,
                          "show-empty": "",
                          "empty-text": _vm.$t(
                            "apeironGwApp.lieSnp.tabla.empty"
                          ),
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(activo)",
                            fn: function (data) {
                              return [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      data.item?.activo
                                        ? _vm.$t("apeironGwApp.lieSnp.form.si")
                                        : _vm.$t("apeironGwApp.lieSnp.form.no")
                                    ),
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "cell(acciones)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value: _vm.$t(
                                          "apeironGwApp.lieSnp.acciones.verDetalle"
                                        ),
                                        expression:
                                          "$t('apeironGwApp.lieSnp.acciones.verDetalle')",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    attrs: { size: "sm", variant: "outline" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.mostrarModalDetalleLie(
                                          data.item
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "card-text",
                                        variant: "primary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.desactivar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.lieSnp.acciones.desactivar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: data.item?.activo,
                                            expression: "data.item?.activo",
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.mostrarModalDesactivarLie(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "check-circle",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.activar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.lieSnp.acciones.activar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !data.item?.activo,
                                            expression: "!data.item?.activo",
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.mostrarModalActivarLie(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "circle",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.editar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.lieSnp.acciones.editar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editarLie(data.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "pencil",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.eliminar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.lieSnp.acciones.eliminar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.mostrarModalEliminarLie(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "trash",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.registros,
                          "per-page": _vm.perPage,
                          "aria-controls": "my-table",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.esEscritura
                ? _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            "b-alert",
                            { attrs: { show: "", variant: "info" } },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.lieSnp.mensajes.guardarSeccion",
                                      {
                                        guardarSeccion: _vm
                                          .$t(
                                            "apeironGwApp.lieSnp.acciones.guardarSeccion"
                                          )
                                          .toString(),
                                      }
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "mt-2",
                          staticStyle: { "text-align": "end" },
                          attrs: { cols: "3" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                block: "",
                                variant: "primary",
                                disabled: !_vm.esEscritura,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.guardarLies()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.lieSnp.acciones.guardarSeccion"
                                    )
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "save" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { id: "modal-detalle", size: "xl" },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-title",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.lieSnp.modal.tituloDetalle"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "modal-footer",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarModalDetalle = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.mostrarModalDetalle,
                            callback: function ($$v) {
                              _vm.mostrarModalDetalle = $$v
                            },
                            expression: "mostrarModalDetalle",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.lieSnp.form.nombreDeLaLie"
                                        ),
                                        "label-for": "input-nombre-linea",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-nombre-linea",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.lieSnp.form.nombreDeLaLie"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.lieSeleccionada.nombreDeLinea,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.lieSeleccionada,
                                              "nombreDeLinea",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "lieSeleccionada.nombreDeLinea",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.lieSnp.form.clasificacion"
                                        ),
                                        "label-for": "input-clasificacion",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "input-clasificacion",
                                          options: _vm.clasificaciones,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.lieSnp.form.clasificacion"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.lieSeleccionada.clasificacion,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.lieSeleccionada,
                                              "clasificacion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "lieSeleccionada.clasificacion",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.lieSnp.form.fechaAlta"
                                        ),
                                        "label-for": "input-fecha-alta",
                                      },
                                    },
                                    [
                                      _c("b-form-datepicker", {
                                        attrs: {
                                          id: "input-fecha-alta",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.lieSnp.form.fechaAlta"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.lieSeleccionada.fechaAlta,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.lieSeleccionada,
                                              "fechaAlta",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "lieSeleccionada.fechaAlta",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.lieSnp.form.temasIncidenciaNacional"
                                        ),
                                        "label-for":
                                          "input-temas-incidencia-nacional",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-list-group",
                                        {
                                          staticClass:
                                            "area-responsive area-responsive-lista",
                                        },
                                        _vm._l(
                                          _vm.lieSeleccionada
                                            .temasPrioritariosPeciti,
                                          function (tema) {
                                            return _c(
                                              "b-list-group-item",
                                              { key: tema.idTemaPeciti },
                                              [
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c("b-col", [
                                                      _c("span", {
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            tema.temaPeciti
                                                          ),
                                                        },
                                                      }),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.lieSnp.form.institucionSede"
                                        ),
                                        "label-for": "input-sede",
                                      },
                                    },
                                    [
                                      _c("b-form-checkbox-group", {
                                        attrs: {
                                          id: "input-sedes",
                                          options: _vm.instituciones,
                                          stacked: "",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.lieSeleccionada.instituciones,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.lieSeleccionada,
                                              "instituciones",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "lieSeleccionada.instituciones",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.lieSnp.form.justificacion"
                                        ),
                                        "label-for": "input-justificacion",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          id: "input-justificacion",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.lieSnp.form.justificacion"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.lieSeleccionada.justificacion,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.lieSeleccionada,
                                              "justificacion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "lieSeleccionada.justificacion",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { id: "modal-eliminar", size: "md" },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-title",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.lieSnp.modal.tituloEliminar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "modal-footer",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        variant: "primary",
                                        disabled: !_vm.esEscritura,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.eliminarLie()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.eliminar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarModalEliminar = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.mostrarModalEliminar,
                            callback: function ($$v) {
                              _vm.mostrarModalEliminar = $$v
                            },
                            expression: "mostrarModalEliminar",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c("div", { staticClass: "d-block text-center" }, [
                            _c("h3", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.lieSnp.modal.detalleEliminar"
                                  )
                                ),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { id: "modal-desactivar", size: "md" },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-title",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.lieSnp.modal.tituloDesactivar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "modal-footer",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        variant: "primary",
                                        disabled: !_vm.esEscritura,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.desactivarLie()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.desactivar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarModalDesactivar = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.mostrarModalDesactivar,
                            callback: function ($$v) {
                              _vm.mostrarModalDesactivar = $$v
                            },
                            expression: "mostrarModalDesactivar",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c("div", { staticClass: "d-block text-center" }, [
                            _c("h3", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.lieSnp.modal.detalleDesactivar"
                                  )
                                ),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { id: "modal-activar", size: "md" },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-title",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.lieSnp.modal.tituloActivar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "modal-footer",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        variant: "primary",
                                        disabled: !_vm.esEscritura,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.activarLie()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.activar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarModalActivar = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.lieSnp.acciones.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.mostrarModalActivar,
                            callback: function ($$v) {
                              _vm.mostrarModalActivar = $$v
                            },
                            expression: "mostrarModalActivar",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c("div", { staticClass: "d-block text-center" }, [
                            _c("h3", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.lieSnp.modal.detalleActivar"
                                  )
                                ),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }